import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/app/layouts/guest.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/app/layouts/public.vue").then(m => m.default || m))
}